import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { FilterPayments } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { apiPayments } from 'helpers/decorators/api'
import { BadgesLevels } from 'components/misc'
import { meta } from 'helpers/decorators'
import { payments as paymentsLayout } from 'constants/layout'
import config from 'config'

@meta({
  title: 'Payments',
  intlKey: 'meta.payments'
})
@apiPayments({
  waiting: true
})
class PaymentsWaiting extends Component {
  static propTypes = {
    payments: PropTypes.object.isRequired,
    setPaymentsWaitingParams: PropTypes.func
  }

  render() {
    const {
      payments: { loading, waiting: { list, offset, limit, pages, sort } },
      setPaymentsWaitingParams
    } = this.props

    return (
      <div>
        <FilterPayments />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={paymentsLayout.tableHeadersWaiting}
          setParams={setPaymentsWaitingParams}
        >
          <Data>
            {list.map(({ id, createdAt, participantRegistration, paidBy }) => (
              <tr key={id}>
                <td>
                  <Link
                    to={`${config.publicPath}/participants/${get(
                      participantRegistration,
                      'award.participant.id'
                    )}`}
                  >
                    {get(participantRegistration, 'award.participant.id')}
                  </Link>
                </td>
                <td>{get(participantRegistration, 'firstName')}</td>
                <td>{get(participantRegistration, 'lastName')}</td>
                <td>{createdAt && <FormattedDate value={createdAt} />}</td>
                <td>{get(participantRegistration, 'email')}</td>
                <td>{get(participantRegistration, 'organizationName')}</td>
                <td>
                  <BadgesLevels
                    levels={[
                      {
                        awardLevel: get(participantRegistration, 'awardLevel')
                      }
                    ]}
                    single
                  />
                </td>
                <td>{get(paidBy, 'translationText')}</td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default PaymentsWaiting
